const INIT_STATE = {
  loading: false,
  error: false,
  errorMessage: null,
	list: [],
	item: null,
	action: null
};

const reducer = (state = INIT_STATE, action)=>{
	switch (action.type) {
		case 'GET_CATEGORIES':
			return { ...state, loading: true, error: false, errorMessage: null, action: null };

		case 'GET_CATEGORIES_SUCCESS':
			return { ...state, loading: false, error: false, errorMessage: null, list: action.payload.data, action: null };

		case 'GET_CATEGORIES_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null };

		case 'GET_CATEGORY':
			return { ...state, loading: true, error: false, action: null };

		case 'GET_CATEGORY_SUCCESS':
			return { ...state, loading: false, error: false, item: action.payload.data, action: null };

		case 'GET_CATEGORY_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null };

		case 'CREATE_CATEGORY':
			return { ...state, loading: true, error: false, action: null }

		case 'CREATE_CATEGORY_SUCCESS':
			return { ...state, loading: false, error: false, action: 'CREATED', item: action.payload.data }

		case 'CREATE_CATEGORY_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

		case 'UPDATE_CATEGORY':
			return { ...state, loading: true, error: false, action: null }

		case 'UPDATE_CATEGORY_SUCCESS':
			return { ...state, loading: false, error: false, action: 'UPDATED', item: action.payload.data }

		case 'UPDATE_CATEGORY_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

		case 'DELETE_CATEGORY':
			return { ...state, loading: true, action: null }

		case 'DELETE_CATEGORY_SUCCESS':
			return { ...state, loading: false, error: false, action: 'DELETED' }

		case 'DELETE_CATEGORY_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

		default:
			return state;
	}
};

export default reducer;